import { createSelector, Selector } from 'reselect/lib';
import { RootState } from 'store';
import type {
    InitialForgotPasswordState,
    ForgotPasswordType,
} from './forgotPasswordActions';

export const forgotPasswordSelector: Selector<InitialForgotPasswordState> = (
    state: RootState,
) => state.forgotPassword;

export const forgotPasswordAnswersSelector: Selector<ForgotPasswordType> = createSelector(
    forgotPasswordSelector,
    (forgotPassword: InitialForgotPasswordState) => forgotPassword.answers,
);
